import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { useHistory } from 'react-router-dom';
import Date from '../../Atoms/Date';
import Title from '../../Atoms/Title';

import { ISearchItemProps } from './SearchItem.definitions';

/** CSS import */
import Styles from './SearchItem.module.scss';

const SearchItem: React.FC<ISearchItemProps> = ({
  title,
  date,
  image,
  link,
  onClose,
}: ISearchItemProps) => {
  const history = useHistory();

  const navigateToArticleDetail = (
    e: React.MouseEventHandler<HTMLAnchorElement>,
  ) => {
    e.preventDefault();
    if (onClose) onClose();
    history.push(link);
  };

  return (
    <a href={'#'} onClick={navigateToArticleDetail}>
      <div className={Styles['wrapper']}>
        <div className={Styles['content-container']}>
          <div>
            <Title text={title} />
            <Date text={date} />
          </div>
          <KickImage src={image} alt={title} className={Styles['image']} />
        </div>
      </div>
    </a>
  );
};

export default SearchItem;
